/* src/app/home/export-comments-modal/export-comments-modal.component.scss */
:host {
  width: fit-content;
}
:host.french h4 {
  margin-right: 28px;
}
.modal-header {
  padding: 22px 32px 0 60px;
  border-bottom: none;
  margin-bottom: 16px;
}
.modal-header h4 {
  font-size: 32px;
  margin-bottom: 0;
  white-space: pre;
}
.modal-body {
  padding: 0 75px 0 60px;
  position: relative;
}
.modal-body input[type=checkbox] {
  display: none;
}
.modal-body .form-check {
  padding-left: 0;
}
.modal-body .form-check label:before {
  display: inline-block;
  content: "";
  width: 24px;
  height: 24px;
  color: black;
  border: 1px solid #979797;
  border-radius: 4px;
  cursor: pointer;
  vertical-align: middle;
  margin-right: 8px;
}
.modal-body input[type=checkbox]:checked + label:before {
  color: #00857D;
  content: "\e622" !important;
  font-size: 11px;
  font-family: upsicons, fantasy !important;
  background: #fff;
  text-align: center;
  line-height: 24px;
  font-weight: bolder;
}
.modal-footer {
  border-top: none;
  padding: 28px 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
}
.modal-footer .btn-green {
  color: white;
  font-size: 13px;
  background-color: #00857D;
  border-radius: 35px;
  width: 118px;
  height: 36px;
  margin: 0;
}
.modal-footer .btn-green:disabled {
  color: #757575;
}
/*# sourceMappingURL=export-comments-modal.component.css.map */
